export default __webpack_public_path__ + "static/media/040_tunnel.vp8.5bc659db.webm";